<template>
    <div class="main">
        <c-panel :title="titulo" :titleIcon="icone">
            <metrica></metrica>
        </c-panel>
    </div>
</template>
<script>
import metrica from "./metrica"
export default {
    components: { metrica },
    data () { return { titulo: '', icone: '' } },
    created () {
        this.titulo = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.icone = 'fas fa-chart-line'
    }
}
</script>
